import { Directive } from '@angular/core';

import { classes } from '../../../utils/src';

@Directive({
  selector: '[knxAlertDescription]',
  host: {
    'data-slot': 'alert-description',
  },
})
export class KnxAlertDescription {
  constructor() {
    classes(
      () =>
        'text-muted-foreground [&_a]:hover:text-foreground text-sm text-balance md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4',
    );
  }
}
